
<div class="dashboardMain" id="activeButtDIV">
    
  <app-left-menu></app-left-menu>    
  <div class="admin-panel clearfix">
    <div class="main">
             
  
              <app-top-menu></app-top-menu>
  
             
  
  
              <div id="myMatche" class="myMatchesStyle" >
                
        
        

  
        <div class="mainContent clearfix">
                <div class="samplecover-spin" id="samplecover-spin" *ngIf="logshortlistedspinner"></div>
                 <div class="dashMainCont" *ngIf="!logshortlistedspinner">
                   <div class="dashMainInner">
                      <div class="matchesInner">
                        <div class="row">
        
                          
                         <div *ngIf="shortlistedval?.length > 0"> 
                      <div *ngFor="let shortlistedData of shortlistedval" id="shortlisthide_{{shortlistedData.MemberID}}"> 
                          <div class="col-md-4">
                            <div class="matchesDiv">
                               
                                <div class="matchesPic">
                                  <div class="coun" *ngIf="shortlistedData.MemberCNtMultiplePhotos > 0">{{shortlistedData.MemberCNtMultiplePhotos}}</div>
                                  <div class="leftA"> <i class="fa fa-angle-left"></i> </div>
                                  <div class="rightA"> <i class="fa fa-angle-right"></i> </div>
                                    <img [src]='photopath+shortlistedData.MemberPhotoPath'>
                                    <div *ngIf="shortlistedData.MemberIsPhotoUpload == '0' && shortlistedData.MembPhotoAddFlag== '0'">
                                      <button class="requestBtUp" id="requestphoto{{shortlistedData.MemberID}}"(click)="photoRequestDash($event.target,shortlistedData)">Request Photo</button>
                                    </div>
    
                                    <div *ngIf="shortlistedData.MemberIsPhotoUpload == '0' && shortlistedData.MembPhotoAddFlag== '1'">
                                      <button class="requestBtUp" id="requestphoto{{shortlistedData.MemberID}}"disabled>Photo Request Sent</button>
                                    </div>
                                    <i class="fa fa-camera phoIco" *ngIf="shortlistedData.MemberCNtMultiplePhotos > 0"></i>
                                </div>
                                <div class="callDetais">
                                    <div class="floatNeed">
                                    <span data-tooltip="Call Now"><i class="fa fa-phone phoneIc" (click)="openMOdel(shortlistedData,masterUrl)"></i></span>

<span data-tooltip="Sent Interest" *ngIf="shortlistedData.MemberSentInterestFlag !== '0'">
<i class="fa fa-heart heartIc likeIntro" id="sentInterst{{shortlistedData.MemberID}}" *ngIf="shortlistedData.MemberSentInterestFlag !== '0'"></i>
<i class="fa fa-heart heartIc" id="sentrunInterst{{shortlistedData.MemberID}}" *ngIf="shortlistedData.MemberSentInterestFlag == '0'" (click)="memberInterestlist(shortlistedData)"></i>
</span>

<span data-tooltip="Send Interest" *ngIf="shortlistedData.MemberSentInterestFlag == '0'">
<i class="fa fa-heart heartIc likeIntro" id="sentInterst{{shortlistedData.MemberID}}" *ngIf="shortlistedData.MemberSentInterestFlag !== '0'"></i>
<i class="fa fa-heart heartIc" id="sentrunInterst{{shortlistedData.MemberID}}" *ngIf="shortlistedData.MemberSentInterestFlag == '0'" (click)="memberInterestlist(shortlistedData)"></i>
</span>


<span data-tooltip="Sent Interest">
<i class="fa fa-heart heartIc hideHeart" id="sentshowInterst{{shortlistedData.MemberID}}"></i>
</span>

    <input type="hidden" name="hiddeninterest{{shortlistedData.MemberID}}" id="hiddeninterest{{shortlistedData.MemberID}}" value="{{shortlistedData.MemberSentInterestFlag}}" [(ngModel)]="shortlistedData.MemberSentInterestFlag">

                                    <span data-tooltip="Shortlist Profile">
                                    <i class="fa fa-star starIc shortLis"  id="shortListID{{shortlistedData.MemberID}}" *ngIf="shortlistedData.MemberShortlistFlag !== '0'" (click)="membershortlist(shortlistedData)"></i>
                                    
                                    <i class="fa fa-star starIc" id="shortListID{{shortlistedData.MemberID}}" *ngIf="shortlistedData.MemberShortlistFlag == '0'"  (click)="membershortlist(shortlistedData)"></i>

                                    <input type="hidden" name="hiddenshort{{shortlistedData.MemberID}}" id="hiddenshort{{shortlistedData.MemberID}}" value="{{shortlistedData.MemberShortlistFlag}}" [(ngModel)]="shortlistedData.MemberShortlistFlag">
                                  </span>
                                    </div>
        
                                    <div class="detailsOuter">
                                    <h4 class="callDetaillsName">{{shortlistedData.MemberName}} ({{shortlistedData.MemberProfileID}})</h4>
                                    <p>{{shortlistedData.MemberEducation}}, Job-City - {{shortlistedData.MemberJobCity}}</p>
                                    <p>{{shortlistedData.MemberAge}} yrs, {{shortlistedData.MemberHeight}} | {{shortlistedData.MemberMartialStatus}}</p>
                                    <p>{{shortlistedData.MemberCaste}}, {{shortlistedData.MemberNativePlace}} </p>
                                  </div>
                                    
                                    <button type="button" class="proDetailsBt" (click)="memberdetailspost(shortlistedData)">
                                      View Profile
                                    </button>
                                </div>
                            </div>
                        </div>
                      </div>
                      </div>
                      <div *ngIf="shortlistedval==0" class="noDataMessage">
                        <img src="../../assets/images/no-data-pana.png"/>
                        {{myMessage}}
                      </div>
          </div>
        
                        
        
        
        
                        </div>
                      </div>
                   </div>
                 </div>
              <!-- </div> -->
  
           
  
  
  
  
  
  </div>
  
      </div>
  </div>
  </div>    
  
  <div class="modal fade success-popup in" id="callModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style=" padding-left: 17px;">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content">
        
        <div class="modal-body text-center">
          <i class="fa fa-close callPopDele" (click)="closePopup()" data-dismiss="modal"></i>
           <div class="calImgDiv" id="callImgDivs">
            <img src="" >
           </div>
           <h4 id="popupName">Contact Akshda Meshra on</h4>
            <p id="popupContact"></p>
        </div>
        <div class="modal-footer" id="popupupgrads">
          
        </div>
      </div>
    </div>
  </div>
  
  

